import { Action, CustomTagType, DockType, ErrorCodes, OperationType, Position, WarningType, WindowType } from "puzzle";
import ReopenDialog from "../../components/SubmissionsList/ActionToolbar/Reopen/ReopenDialog";

export const reopen_submission: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  data: {
    template: {
      activeDialog: 'ReopenDialog'
    }
  },
  persistent: ['activeDialog'],
  type: OperationType.addPersistentData
}, {
  data: {
    template: {
      asSubName: true,
      bind: {
        submissionName: '{submissionData.submissionName}',
        submissionId: '{submissionData.submissionId}'
      }
    }
  },
  type: OperationType.data
}, {
  data: {
    method: 'post',
    template: {
      bind: {
        url: '"/submissions/" + {submissionId} + "/showReopenTargets"'
      }
    },
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'gridData',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{gridData}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  data: {
    method: 'post',
    template: {
      bind: {
        url: '"/submissions/" + {submissionId} + "/reopenWorkflows"'
      }
    },
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'workflowData',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{workflowData}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  className: 'xxl reopen',
  children: [{
    render: ReopenDialog,
    propArgs: ['submissionData', 'reopenInProcess']
  }],
  items: [{
    btnName: 'submissionName',
    btnConfig: {
      args: ['submissionId', 'submissionName', 'asSubName'],
      customTagType: CustomTagType.label,
      dock: DockType.top,
      pos: Position.end
    },
    operations: []
  }, {
    btnName: 'ESCAPE',
    close: false,
    operations: [{
      windowType: WindowType.warning,
      type: OperationType.closeWindow
    }, {
      name: 'exitReopen',
      type: OperationType.action
    }]
  }],
  title: 'reopenDialog.title',
  type: OperationType.dialog
}, {
  moduleName: 'ReopenDialog',
  args: ['gridData', 'workflowData'],
  name: 'setGridData'
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];

export const exitReopen: Action = [{
  moduleName: 'ReopenDialog',
  name: 'checkForUploadedFiles',
  mappingName: 'uploadedFilesExist',
  type: OperationType.addOperationData
}, {
  condition: '{uploadedFilesExist}',
  conditionOperations: [{
    type: OperationType.warning,
    title: 'exitReopen.title',
    text: 'exitReopen.text',
    className: 'sm confirm-light',
    items: [{
      btnName: 'exitReopen.cancel',
      btnConfig: {
        fillMode: 'flat',
        pos: Position.end
      },
      operations: []
    }, {
      close: false,
      btnName: 'exitReopen.exit',
      btnConfig: {
        pos: Position.end,
        themeColor: 'error'
      },
      operations: [{
        name: 'closeReopen',
        type: OperationType.action
      }]
    }]
  }],
  elseOperations: [{
    name: 'closeReopen',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const closeReopen: Action = [{
  persistent: ['activeDialog'],
  type: OperationType.removePersistentData
}, {
  windowType: WindowType.warning,
  type: OperationType.closeWindow
}, {
  windowType: WindowType.dialog,
  type: OperationType.closeWindow
}, {
  name: 'refreshApp',
  type: OperationType.action
}];

export const reopenWarningTemplate: Action = [{
  placeholders: {
    className: 'tp-text-semibold',
    template: {
      bind: {
        title: '{title}',
        text: '{text}'
      }
    }
  },
  warningType: WarningType.warning,
  className: 'sm warning footer-centered',
  title: 'reopenWarningTemplate.title',
  text: 'reopenWarningTemplate.text',
  items: [{
    operations: [],
    btnName: 'filesTabPromoteDemoteWarnings.close',
    btnConfig: {
      pos: Position.end,
      fillMode: 'flat'
    }
  }],
  type: OperationType.warning
}];

export const resetReopenData: Action = [{
  moduleName: 'ReopenDialog',
  name: 'resetProcessing'
}];
